import React from 'react';
import LoadingBar from 'react-redux-loading-bar';
import { Link } from 'react-router-dom';


export default ({ isAuthenticated, current }) => (
  <nav className="navbar is-fixed-top is-transparent" aria-label="main navigation">
    <LoadingBar />
    <div className="container top-nav-container">
      <div className="navbar-brand">
        <div className="navbar-item">
          <Link className="" to="/">
            <img src="https://mhk-cdn.sgp1.digitaloceanspaces.com/static/img/mail/MHK_Logo_web.png" alt="MyHomeKart" />
          </Link>
        </div>
      </div>
      <div className="navbar-item">
        <div className="dropdown is-hoverable is-right">
          <div className="dropdown-trigger">
            <button className="button is-light" aria-haspopup="true" aria-controls="dropdown-menu4">
              <span>Login</span>
              <span className="icon is-small">
                <i className="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div className="dropdown-menu" id="dropdown-menu4" role="menu">
            <div className="dropdown-content">
              <a href="http://www.old.myhomekart.com/signup_society_page.html?todo=login" className="dropdown-item">
                Login
                  </a>
              <a href="http://www.old.myhomekart.com/signup_individual_page.html?todo=signup" className="dropdown-item">
                Sign Up As Individual
                  </a>
              <a href="http://www.old.myhomekart.com/signup_society_page.html?todo=signup" className="dropdown-item">
                Sign up as Housing Society
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  // <header id="header">
  //   <ul id="links">
  //     {links.map((link, index) => {
  //       const TheLink = <HeaderLink key={index} current={current} {...link} />;

  //       if (link.hasOwnProperty('auth')) {
  //         if (link.auth && isAuthenticated) {
  //           return TheLink;
  //         } else if (!link.auth && !isAuthenticated) {
  //           return TheLink;
  //         }

  //         return null;
  //       }

  //       return TheLink;
  //     })}
  //   </ul>
  // </header>
);



// WEBPACK FOOTER //
// ./src/app/header.js